import { render, staticRenderFns } from "./MarketRates4.vue?vue&type=template&id=05977bca&scoped=true"
import script from "./MarketRates4.vue?vue&type=script&lang=js"
export * from "./MarketRates4.vue?vue&type=script&lang=js"
import style0 from "./MarketRates4.vue?vue&type=style&index=0&id=05977bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05977bca",
  null
  
)

export default component.exports